import React from "react";
import { RepassesSetoriaisPage } from "./repassesSetoriais.page";
import { RepassesSetoriaisProvider } from "./context/repasses-setoriais-context";

export function RepassesSetoriaisFactory() {
    return (
        <RepassesSetoriaisProvider>
            <RepassesSetoriaisPage></RepassesSetoriaisPage>
        </RepassesSetoriaisProvider>
    );
}
